import { ACCOUNT } from '../constants/drawer'
import { getLens } from '../mfcLogic/lens'
import { getModalState, getScreenState } from '../state/getState'

/**
 * Google Ads tag for app.mfc
 */
export const GA_TRACKING_ID = 'AW-18074639362'

/**
 * Google Analytics 4 property for app.mfc
 */
export const GA_MEASUREMENT_ID = 'G-L7ZDTE8HFM'

/**
 * Google tag for app.mfc
 */
export const GA_TAG_ID = 'GT-T5MRN4Q3'

/**
 * Umami Tracking IDs per environment
 */
export const UMAMI_PROD_ID = 'eab0edc1-8118-42bd-a3e8-71b3c8c75aa7'
export const UMAMI_STG_ID = '03f64e8c-47b3-44a1-b170-de8fc06566ec'
export const UMAMI_EXP_ID = '95ad8102-912d-4084-98f8-c37099603ba5'
export const UMAMI_DEV_ID = '260ab718-93f4-4c53-ac61-684640717fdb'

export const denyGtagConsent = () => {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
        return
    }
    window.gtag('consent', 'update', {
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        analytics_storage: 'denied',
    })
}

/**
 * Google Ads conversion label for a completed QuickBuy token purchase
 */
export const GA_QUICKBUY_CONVERSION_LABEL = 'v79NCNzWw5MdEIK41KpD'

/**
 * Google Ads conversion label for a submitted signup form
 */
export const GA_SIGNUP_CONVERSION_LABEL = '49imCPbqz5MdEIK41KpD'

type GtagConversion = {
    send_to: string
    value?: number
    currency?: string
    transaction_id?: string
}

const sendGtagConversion = (
    label: string,
    params: Omit<GtagConversion, 'send_to'> = {},
) => {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
        return
    }

    const conversion: GtagConversion = {
        send_to: `${GA_TRACKING_ID}/${label}`,
        ...params,
    }

    try {
        window.gtag('event', 'conversion', conversion)
    } catch (ex) {
        console.error(`[sendGtagConversion]: ${ex}`)
    }
}

type PurchaseConversionResponse = {
    product?: { amount?: number | string }
    purchase_result?: { purchase_id?: number | string }
}

/**
 * Report a completed token purchase to Google Ads as a conversion
 */
export const trackPurchaseConversion = (
    response: PurchaseConversionResponse,
) => {
    const purchaseId = response?.purchase_result?.purchase_id
    sendGtagConversion(GA_QUICKBUY_CONVERSION_LABEL, {
        value: Number(response?.product?.amount) || 0,
        currency: 'USD',
        ...(purchaseId ? { transaction_id: String(purchaseId) } : {}),
    })
}

/**
 * Report a successful signup submission to Google Ads as a conversion
 */
export const trackSignupConversion = () =>
    sendGtagConversion(GA_SIGNUP_CONVERSION_LABEL)

export const trackAnalyticsEvent = ({ action, data = {} }) => {
    if (shouldReportUmami()) {
        window.umami.track(action, data)
    }
}

export const shouldReportUmami = () => {
    if (typeof window !== 'undefined' && window.umami) return true
    else return false
}

type Surface = 'moreMenu' | 'myAccount'

export const trackMenuClick = (item: string) =>
    getLens()?.Menu_Click({
        item,
        surface: (getModalState().drawer.type === ACCOUNT
            ? 'moreMenu'
            : 'myAccount') as Surface,
        orientation: getScreenState().portrait ? 'portrait' : 'landscape',
    })
